import { API_Route_Audits } from "../Shared/Urls.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { AuditLog_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { some, unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { defaultOf, equals, createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { mapFetchError } from "../Promises.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { globalCtx } from "../Context.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { equalsWith } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { Target, tableView } from "../AuditLogs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { Skeleton } from "@mui/material";

export function fetchRouteAuditLogs(routeId, callback) {
    const url = API_Route_Audits(routeId);
    const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_2, pr_1, decoder, data_1, caseStrategy_2, extra_2;
        return Promise.resolve((pr_2 = ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(AuditLog_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(AuditLog_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then(mapFetchError))), pr_2.then(callback)));
    }));
    pr_3.then();
}

export function TableView(tableViewInputProps) {
    let elems;
    const routeId = tableViewInputProps.routeId;
    const ctx = reactApi.useContext(globalCtx);
    const patternInput = reactApi.useState(undefined);
    const auditLogs = patternInput[0];
    const isMobile = ctx.Responsive.tag === 0;
    useEffectOnce(() => {
        fetchRouteAuditLogs(routeId, (_arg) => {
            if (_arg.tag === 1) {
                console.error(some(_arg.fields[0]));
            }
            else {
                patternInput[1](_arg.fields[0]);
            }
        });
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
        maxWidth: 1200,
    }], (elems = toList(delay(() => {
        let testExpr, audits_1;
        return (auditLogs != null) ? (((testExpr = auditLogs, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 0))) ? singleton(createElement("p", {
            children: ["Ingen registerte endringer"],
        })) : ((audits_1 = auditLogs, singleton(tableView(isMobile, new Target(1, [routeId]), audits_1))))) : singleton(MuiHelpers_createElement(Skeleton, [["height", 400]]));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

//# sourceMappingURL=RouteAuditLogs.js.map
